"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCampaignAndQuestions = void 0;

var _feedbackService = require("../../apis/feedbackService");

var _reactAsyncHook = require("react-async-hook");

const useCampaignAndQuestions = (accessToken, environment, campaignId, questionId) => {
  const {
    feedbackServiceBaseUrl,
    useCache
  } = environment;
  const campaign = (0, _reactAsyncHook.useAsync)(() => {
    if (!accessToken) {
      return Promise.resolve(undefined);
    }

    return (0, _feedbackService.getCampaign)(feedbackServiceBaseUrl, useCache, accessToken, campaignId);
  }, [feedbackServiceBaseUrl, accessToken, campaignId]);
  const questions = (0, _reactAsyncHook.useAsync)(async () => {
    if (!accessToken) {
      return Promise.resolve(undefined);
    }

    if (questionId) {
      const question = await (0, _feedbackService.getQuestion)(feedbackServiceBaseUrl, useCache, accessToken, campaignId, questionId);

      if (!question) {
        return undefined;
      }

      return [question];
    }

    return (0, _feedbackService.getQuestions)(feedbackServiceBaseUrl, accessToken, campaignId);
  }, [feedbackServiceBaseUrl, accessToken, campaignId, questionId]);
  return {
    campaign,
    questions
  };
};

exports.useCampaignAndQuestions = useCampaignAndQuestions;